import { backendUrls, getAccessToken } from "@puffin/app-frame-api";
import type { RegistryData, SpecViolation } from "../types";

const DATA_URL = `${backendUrls.registryReindeer}/api/internal/data`;
const VALIDATION_URL = `${backendUrls.registryReindeer}/api/internal/validate`;

const request = async <T>(url: string, init?: RequestInit): Promise<T> => {
  const accessToken = await getAccessToken();
  const headers = new Headers(init?.headers);

  if (accessToken) {
    headers.set("Authorization", `Bearer ${accessToken}`);
  }

  const response = await fetch(url, { ...init, headers });
  if (!response.ok) {
    throw new Error(`RegistryReindeer request failed with status ${response.status}`);
  }

  return response.json() as Promise<T>;
};

export const fetchRegistryData = (): Promise<RegistryData> => request(DATA_URL);

export const validateServiceSpec = (yaml: string): Promise<SpecViolation[]> => {
  return request(VALIDATION_URL, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ yaml }),
  });
};
